export default "__VITE_ASSET__DxinEQg4__"